import { FC, useMemo } from 'react';
import { useFieldState } from 'informed';
import { Form } from '@repo-level/core-front';

import { FormGroup } from 'components/form/groups/FormGroup';
import { Select } from 'components/form/Select';
import { required } from 'helpers/validators';
import { OfUnion } from 'types/common';
import { ScFieldExpiryDateRow } from './styled';

export const FieldCascadeSelect: FC<
  OfUnion<Form.MethodField>[Form.MethodFieldType.CascadeSelect]
> = ({
  fieldName,
  label,
  options,
  secondaryFieldName,
  secondaryLabel,
  secondaryOptionsMapByMainValue,
}) => {
  const primaryOptionsFormatted = useMemo(
    () => options.map(({ label, value }) => ({ name: label, value })),
    [options]
  );

  const fieldStatePrimary = useFieldState<string | undefined>(fieldName);

  const selectedPrimary = useMemo(() => {
    return fieldStatePrimary == null ? undefined : fieldStatePrimary.value;
  }, [fieldStatePrimary]);

  const secondaryOptionsFiltered = useMemo(() => {
    if (selectedPrimary == null) return;

    const secondaryOptions = secondaryOptionsMapByMainValue[selectedPrimary];

    if (secondaryOptions == null) return;

    return secondaryOptions.map(({ label, value }) => ({ name: label, value }));
  }, [selectedPrimary, secondaryOptionsMapByMainValue]);

  return (
    <FormGroup title={label || fieldName}>
      <ScFieldExpiryDateRow $list>
        <Select
          field={fieldName}
          placeholder={label || fieldName}
          options={primaryOptionsFormatted}
          validate={required}
        />

        {secondaryOptionsFiltered && (
          <Select
            field={secondaryFieldName}
            placeholder={secondaryLabel || secondaryFieldName}
            options={secondaryOptionsFiltered}
            validate={required}
          />
        )}
      </ScFieldExpiryDateRow>
    </FormGroup>
  );
};
